// "Translate" on every notice and message: the AI puts the text into the reader's language. Shown below the original, plain text, labelled.
import { useState } from 'react'
import { translate } from './data'
import { LANGS, readerLang } from './core'

const saved = () => { try { return localStorage.getItem('hc_comms_lang') } catch (e) { return null } }
export default function Translate({ kind, id }) {
  const [lang, setLang] = useState(() => readerLang(saved() || (typeof navigator !== 'undefined' && navigator.language)))
  const [state, setState] = useState({ busy: false, text: '', err: '' })
  const go = async l => {
    setState({ busy: true, text: '', err: '' })
    try { setState({ busy: false, text: await translate(kind, id, l), err: '' }) } catch (e) { setState({ busy: false, text: '', err: e.message }) }
  }
  const change = l => { setLang(l); try { localStorage.setItem('hc_comms_lang', l) } catch (e) {} ; go(l) }
  if (!id) return null
  if (!state.text && !state.busy && !state.err) return <button type="button" className="hc-comms-link" onClick={() => go(lang)} style={LINK}>Translate</button>
  return (
    <div data-comms-translation style={{ marginTop: 6, padding: '8px 10px', borderRadius: 8, background: 'var(--bg)', fontSize: 13 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 11, color: 'var(--muted)', marginBottom: 4 }}>
        <span>AI translation into</span>
        <select aria-label="Language" value={lang} onChange={e => change(e.target.value)} style={{ fontSize: 11, background: 'transparent', color: 'inherit', border: '1px solid var(--line-2, var(--border))', borderRadius: 5 }}>{Object.entries(LANGS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select>
        <button type="button" onClick={() => setState({ busy: false, text: '', err: '' })} style={{ ...LINK, marginLeft: 'auto' }}>Hide</button>
      </div>
      {state.busy ? <span style={{ color: 'var(--muted)' }}>Translating…</span> : state.err ? <span style={{ color: '#C0434A' }}>{state.err}</span> : <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{state.text}</div>}
    </div>
  )
}
const LINK = { background: 'none', border: 'none', padding: 0, color: 'var(--muted)', fontSize: 12, cursor: 'pointer', textDecoration: 'underline' }
